<div class="flex-center">
    <datepicker
        [id]="startId()"
        [(value)]="feeWaiver().startDate"
        [required]="true"
        [showClear]="false"
        [view]="'month'"
        [minDate]="feeWaiverStatus() === feeWaiverStatusEnum.ACTIVE ? undefined : firstDayOfCurrentMonth"
        [selectionMode]="'single'"
        [showButtonBar]="false"
        [invalid]="isInvalid()"
        [disabled]="feeWaiverStatus() === feeWaiverStatusEnum.ACTIVE || disabled()"
        [size]="'small'"
        (valueChange)="handleDateChange()"></datepicker>
    <i class="fa-regular fa-arrow-right fa-xl"></i>
    <datepicker
        [id]="endId()"
        [(value)]="feeWaiver().endDate"
        [required]="true"
        [showClear]="false"
        [view]="'month'"
        [minDate]="waiverWithMonthInPast() ? lastMonthDate : firstDayOfCurrentMonth"
        [selectionMode]="'single'"
        [showButtonBar]="false"
        [placeholder]="endDatePlaceholder()"
        [disabled]="disabled()"
        [size]="'small'"
        (valueChange)="handleDateChange()"></datepicker>
    @if (displayIntervalInTooltip()) {
        <i [pTooltip]="feeWaiverIntervalInfo()" [escape]="false" class="fa-light fa-circle-info"></i>
    }
</div>

<div class="flex-center">
    @if (isInvalid()) {
        <p class="error">{{ 'group.feeWaivers.manageWaivers.startDateInvalid' | translate }}</p>
    }
    @if (feeWaiverIntervalInfo() && displayIntervalInline()) {
        <p class="info" [innerHTML]="feeWaiverIntervalInfo()"></p>
    }
</div>
